import { render, staticRenderFns } from "./TableUserComponent.vue?vue&type=template&id=206af05b&scoped=true"
import script from "./TableUserComponent.vue?vue&type=script&lang=js"
export * from "./TableUserComponent.vue?vue&type=script&lang=js"
import style0 from "./TableUserComponent.vue?vue&type=style&index=0&id=206af05b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206af05b",
  null
  
)

export default component.exports